<script setup>
import { computed } from 'vue'
import { Table } from '@drama/ui'

import AuditRecords from './AuditRecords.vue'
import { clip, useAuditText } from './audit-text.js'
import { asArray, characterName, recordingNotes } from './run-observer.js'

const props = defineProps({
  pack: { type: Object, required: true },
  branch: { type: Object, required: true },
  // characterRecord() 的结果。
  record: { type: Object, required: true },
  sources: { type: Map, required: true },
})

const { tr, rangeLabel, memoryKindLabel, errorLabel } = useAuditText()
const columns = computed(() => [
  { key: 'seq', label: tr('characters.witnessTurn'), width: '100px' },
  { key: 'text', label: tr('characters.witnessText'), width: '420px', wrap: true },
  { key: 'audience', label: tr('characters.witnessBy'), width: '220px', wrap: true },
])
const witnessRows = computed(() => props.record.witnessed.map((segment) => ({
  record_key: segment.record_key,
  seq: segment.seq,
  text: segment.text,
  audience: asArray(segment.audience_ids).map((id) => characterName(props.pack, id)).join(tr('separator')),
})))
// 见闻只在剧情记录完成后才有；待记录与记录失败的轮次写成一行提示，不能据此判断人物不知情。
const recordingHint = computed(() => {
  const notes = recordingNotes(props.branch)
  const parts = []
  if (notes.pending_witness_turns.length) {
    parts.push(tr('characters.witnessPending', { turns: notes.pending_witness_turns.map((turn) => turn.seq).join(tr('separator')) }))
  }
  for (const job of notes.failed_witness_jobs) parts.push(tr('characters.witnessFailed', { range: rangeLabel(job), reason: errorLabel(job.error_code) }))
  return parts.join(' · ')
})
const observationRows = computed(() => props.record.observations.map((item) => ({
  key: item.record_id || `${item.record_source}-${item.job_id}-${item.revision}`,
  title: memoryKindLabel(item),
  meta: rangeLabel(item),
  text: item.text,
  record: item,
})))
</script>

<template>
  <div class="au-fold__body">
    <section class="au-group">
      <h4>{{ tr('characters.witnessed') }} · {{ witnessRows.length }}</h4>
      <p v-if="recordingHint" class="au-hint" :title="recordingHint">{{ recordingHint }}</p>
      <div v-if="witnessRows.length" class="au-scroll">
        <Table :columns="columns" :rows="witnessRows" row-key="record_key">
          <template #seq="{ row }">{{ tr('sources.turn', { count: row.seq }) }}</template>
          <template #text="{ row }"><span :title="row.text">{{ clip(row.text, 120) }}</span></template>
        </Table>
      </div>
      <p v-else class="au-empty">{{ tr('empty') }}</p>
    </section>
    <section class="au-group">
      <h4>{{ tr('characters.observations') }} · {{ observationRows.length }}</h4>
      <AuditRecords :rows="observationRows" :sources="sources" />
    </section>
  </div>
</template>
